import React, { useEffect, useRef, useState } from "react";
import { PopoverContainer } from "./style";
import CloseIcon from "../../../assets/img/close-icon.svg";
import { SpinnerLoader } from "../../../components/Preloader";
import { Link } from "react-router-dom";
import { AdminsRoutes } from "../../../routes";

const Popup = ({ isOpen, onClose, title, targetElement, loading, data = [], hasUnreadNotifications }) => {
  const [popoverPosition, setPopoverPosition] = useState({});
  const popoverRef = useRef(null);

  // Since there will only be unread notifications, use all the data
  const notificationList = data || [];

  console.log('Popup - Full data received:', data);
  console.log('Popup - notificationList:', notificationList);
  console.log('Popup - notificationList length:', notificationList.length);
  console.log('Popup - hasUnreadNotifications:', hasUnreadNotifications);
  console.log('Popup - loading:', loading);

  useEffect(() => {
    if (targetElement && popoverRef.current) {
      const targetRect = targetElement.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      let top, left;

      if (viewportWidth <= 768) {
        // Mobile: Position directly below the notification icon
        top = targetRect.bottom + 8; // 8px gap below icon
        left = targetRect.right - 300; // Align right edge of popup with icon, accounting for popup width

        // Ensure popup doesn't go off left edge
        if (left < 16) {
          left = 16; // 16px margin from screen edge
        }

        // Ensure popup doesn't go off right edge
        const popupWidth = 300;
        if (left + popupWidth > viewportWidth - 16) {
          left = viewportWidth - popupWidth - 16;
        }
      } else {
        // Desktop: Original positioning
        top = targetRect.bottom + 8;
        left = targetRect.right - 500;

        // Ensure popup doesn't go off-screen on desktop
        if (left < 16) left = 16;
        if (left + 500 > viewportWidth - 16) {
          left = viewportWidth - 500 - 16;
        }
      }

      // Adjust vertical position if popup would go off bottom of screen
      const popupHeight = viewportWidth <= 768 ? 400 : 500; // Estimated popup height
      if (top + popupHeight > viewportHeight - 16) {
        top = targetRect.top - popupHeight - 8; // Position above icon instead
        if (top < 16) {
          top = 16; // Fallback to top of screen with margin
        }
      }

      setPopoverPosition({
        top: Math.max(16, top),
        left: Math.max(16, left),
      });
    }
  }, [targetElement, isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const isMobile = window.innerWidth <= 768;

  return (
    <PopoverContainer>
      <div className="popover-main-container" onClick={onClose}>
        <div
          ref={popoverRef}
          className="popover-content"
          onClick={(e) => e.stopPropagation()}
          style={{
            position: 'fixed',
            top: `${popoverPosition.top}px`,
            left: `${popoverPosition.left}px`,
            width: isMobile ? '300px' : '500px',
            maxWidth: isMobile ? 'calc(100vw - 32px)' : '500px',
            maxHeight: isMobile ? 'calc(100vh - 100px)' : '80vh',
            zIndex: 9999,
            backgroundColor: 'white',
            border: '1px solid #ddd',
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <div className="popover-header popover-head-area" style={{
            padding: isMobile ? '12px 16px' : '16px 20px',
            borderBottom: '1px solid #eee',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexShrink: 0
          }}>
            <h5 className="popover-title popover-title-tag" style={{
              margin: 0,
              fontSize: isMobile ? '16px' : '18px',
              fontWeight: '600',
              color: '#333'
            }}>{title}</h5>
            <button
              type="button"
              className="close-btn close-modal-button"
              onClick={onClose}
              style={{
                background: 'none',
                border: 'none',
                padding: '4px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <img src={CloseIcon} alt="Close" style={{
                width: isMobile ? '16px' : '20px',
                height: isMobile ? '16px' : '20px'
              }} />
            </button>
          </div>

          {loading ? (
            <div className="popover-body popover-head-container" style={{
              padding: isMobile ? '20px 16px' : '24px 20px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '100px'
            }}>
              <SpinnerLoader />
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : !notificationList?.length ? (
            <div className="popover-body popover-head-container" style={{
              padding: isMobile ? '20px 16px' : '24px 20px',
              textAlign: 'center'
            }}>
              <h6 className="popover-card-tagline" style={{
                margin: 0,
                color: '#666',
                fontSize: isMobile ? '14px' : '16px'
              }}>
                No notifications
              </h6>
            </div>
          ) : (
            <div className="popover-body popover-head-container" style={{
              flex: 1,
              overflowY: 'auto',
              padding: 0
            }}>
              {notificationList?.map((item, index) => {
                console.log(`Notification ${index}:`, item);

                const message =
                  (item?.notificationType === "Withdrawal" ||
                    item?.notificationType === "Deposit") &&
                  item?.notificationMessage?.split(" ").reduce((acc, curr, i) => {
                    if (i === 0 || i === 4) {
                      return `${acc} <span style="color: #00133c; font-weight: bold;">${curr}</span>`;
                    }

                    return `${acc} ${curr}`;
                  }, "");

                let redirectTo = ""

                switch (item.notificationType) {
                  case "Withdrawal":
                    redirectTo = AdminsRoutes.TransactionsBankingWithdrawals
                    break;
                  case "Deposit":
                    redirectTo = AdminsRoutes.TransactionsBankingDeposits
                    break;
                  default:
                    redirectTo = AdminsRoutes.Dashboard
                }

                return (
                  <div
                    key={item.notificationId || index}
                    className="popover-container"
                    style={{
                      background: "#e7dafb",
                      borderBottom: index < notificationList.length - 1 ? '1px solid #ddd' : 'none'
                    }}
                  >
                    <Link
                      to={redirectTo}
                      onClick={onClose}
                      style={{
                        textDecoration: 'none',
                        color: 'inherit',
                        display: 'block',
                        padding: isMobile ? '12px 16px' : '16px 20px'
                      }}
                    >
                      <div className="popover-card-content-left">
                        <h6 className="popover-card-tagline" style={{
                          margin: '0 0 8px 0',
                          fontSize: isMobile ? '14px' : '16px',
                          fontWeight: '600',
                          color: '#333'
                        }}>
                          {item.notificationTitle || 'Notification'}
                        </h6>
                        <p
                          className="popover-card-description"
                          style={{
                            margin: 0,
                            fontSize: isMobile ? '12px' : '14px',
                            color: '#666',
                            lineHeight: '1.4'
                          }}
                          dangerouslySetInnerHTML={{
                            __html: message || item.notificationMessage || 'No message available'
                          }}
                        />
                      </div>
                    </Link>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </PopoverContainer>
  );
};

export default Popup;
